import {
    DEALERPENDINGREQUESTLIST_SUCCESS,
    DEALERPENDINGREQUESTLIST_FAILED,
    RESET_DEALERPENDINGREQUESTLIST,
    LOADING_DEALERPENDINGREQUESTLIST,
    NETWORK_ERROR_DEALERPENDINGREQUESTLIST
} from '../types/index'
import { dealerServices } from "../../config/axios";

const resetDealerPendingRequestList = () => {
    return { type: RESET_DEALERPENDINGREQUESTLIST };
};



const dealerGetPendingRequestList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERPENDINGREQUESTLIST });
    await dealerServices
        .post("pendingRequestList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerGetPendingRequestListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerGetPendingRequestListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERPENDINGREQUESTLIST,
                payload: err
            });
        });
}

function dealerGetPendingRequestListsuccess(data) {
    return {
        type: DEALERPENDINGREQUESTLIST_SUCCESS,
        payload: data
    };
}

function dealerGetPendingRequestListFailed(data) {
    return {
        type: DEALERPENDINGREQUESTLIST_FAILED,
        payload: data
    };
}
export { resetDealerPendingRequestList, dealerGetPendingRequestList }